import { computed, ComputedRef } from 'vue'

/**
 * 组件属性接口
 */
export interface StyleProps {
	mode?: string
	color?: string
	link?: boolean
}

/**
 * 设置 class 的通用 hook
 * @param prefix 组件前缀
 * @param props 组件的 props
 * @returns 计算属性，返回 class 数组
 */
export function useSetClass(prefix: string, props: StyleProps): ComputedRef<string[]> {
	return computed(() => {
		const arr: string[] = []

		// 添加模式类
		if (props.mode) {
			arr.push(`${prefix}-mode-${props.mode}`)

			// 如果同时有 mode 和 color，添加颜色类
			if (props.color) {
				arr.push(`${prefix}-color-${props.color}`)
			}
		}

		// 添加链接样式
		if (props.link) {
			arr.push(`${prefix}-link`)
		}

		return arr
	})
}

/**
 * 设置公共样式类的专用 hook
 * @param props 组件的 props
 * @returns 计算属性，返回公共样式类数组
 */
export function useCommonClass(props: StyleProps): ComputedRef<string[]> {
	return useSetClass('to-common', props)
}
